import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';
import { setOrderAction } from '../../store/actions/orderAction';
import { getGhaInfo } from '../../store/actions/ghaAction';

import pickupOrderRemote from '../../api/pickupOrderRemote';

import PrevNext from '../prevAndNext/PrevNext';
import ProcessBarContainer from '../processBar/ProcessBarContainer';
import DropOffOrderContainer from './DropOffOrderContainer';

import Cart from '../../models/Cart';
import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import PickupOrderModel from '../../models/PickupOrder';
import { UserRoleType } from '../../models/User';
import ManualEntryEdit from '../../models/ManualEntryEdit';

import moment, { Moment } from 'moment';
import MomentUtils from "@date-io/moment";

import { PO_SCHEMA } from '../../utils/pickupOrder';

import cartStyles from '../cart/cart.module.css';

interface DropOffOrderWrapperContainerProps {
  cart: Cart;
  receiveError: Function;
  setOrder: Function;
  getGhaInfo: Function;
  userRole: UserRoleType;
  manualEntryEdit: ManualEntryEdit;
};

interface DropOffOrderWrapperContainerState {
  lastDropOffOrder: PickupOrderModel;
  hasDropOffOrder: boolean;
  pickupDate: Moment;
  orderType: string;
};

class DropOffOrderWrapperContainer extends Component<DropOffOrderWrapperContainerProps, DropOffOrderWrapperContainerState> {

  state ={
    lastDropOffOrder: PO_SCHEMA,
    hasDropOffOrder: false,
    pickupDate: new MomentUtils().date(),
    orderType: 'export'
  }

  componentDidMount() {

    // Manual entry process
    const meOrderNumber: string = this.props.manualEntryEdit.orderNumber;

    if (meOrderNumber) {

      this.loadDropOffOrderByNumber(meOrderNumber);
    } else {
      
      // Regular DO process
      this.loadLastDropOffOrder(this.state.orderType);
    }
  }

  loadLastDropOffOrder = (orderType: string): void => {

    pickupOrderRemote.getLastPickupOrder(orderType).then(this.handleCommonOrderResponse);
  }

  loadDropOffOrderByNumber = (orderNumber: string): void => {

    pickupOrderRemote.getPickupOrder(orderNumber).then(this.handleCommonOrderResponse);
  }

  handleCommonOrderResponse = (resp: ApiResponse<PickupOrderModel>): void => {

    const doo: PickupOrderModel | undefined = resp.result;
    const error: ResponseError | undefined = resp.error;

    if (doo) {
      doo.maskedDriverId = doo.driver_id ? doo.driver_id.replace(/.(?=.{4,}$)/g, '#') : doo.driver_id;
      this.setState({
        lastDropOffOrder: doo,
        hasDropOffOrder: true,
        pickupDate: moment(doo.pickup_date)
      });

      this.props.setOrder(doo);
      this.props.getGhaInfo(doo.id_gha);
    }

    if (error) {
      this.props.receiveError(error);
    }
  }

  renderDoffOrMessage = (): JSX.Element => {

    let doNotShowDO: boolean = false;
    let renderContent: JSX.Element = <span></span>;

    /**
    * If user has clicked on this icon without having any AWB in truckCart.
    */
    if (!this.state.hasDropOffOrder) {
      renderContent = <div className={ cartStyles.emptyCart }>To generate Drop Off Order, first add AWB to Track and click generate.</div>;
      doNotShowDO = true;
    }

    if (doNotShowDO) {
      const prevButtonHref: string = this.props.userRole === UserRoleType.FORWARDER ? '/truck' : '/manual-entry-truck';
      return <Fragment>
              { renderContent }
              <PrevNext prevButton={ { active: true, href:`${prevButtonHref}`, animate: true } } />
            </Fragment>;
    }

    return <DropOffOrderContainer
              dropOffOrder={ this.state.lastDropOffOrder }
              showDetails={ false }
              pickupDate={ this.state.pickupDate }
              showLine={ false }
              userRole={ this.props.userRole }
            />;
  }

  render() {
    
    return (

        <Fragment>
          <ProcessBarContainer type='export' userRole={ this.props.userRole }/>
          { this.renderDoffOrMessage() }
        </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart,
    manualEntryEdit: state.manualEntryEdit
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    setOrder: (order: PickupOrderModel) => dispatch(setOrderAction(order)),
    getGhaInfo: (id: number) => dispatch(getGhaInfo(id))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(DropOffOrderWrapperContainer);